/// <amd-module name="Reporting/Visuals/VisualTitle" />
import React = require("react");
import { DataQualityWarningsComponent } from "Reporting/DataQuality/DataQualityWarningsComponent";
import { css } from "VSS/Platform/Layout";
import { Tooltip } from "VSSUI/TooltipEx";

export interface VisualTitleProps {
    /** Text to render in title */
    text: string;

    /** By default, Visual title indents top, right and left by 10px. Suppression allows container to manually handle positioning.  */
    suppressDefaultPadding?: boolean;

    /** Optional parameter to hide title  */
    hideTitle?: boolean;

    dataQualityWarning?: string;
}
/** Styled Presentation component for a visual header title. */
export class VisualTitle extends React.PureComponent<VisualTitleProps> {
    public render(): JSX.Element {
        return (
            <Tooltip text={this.props.text} overflowOnly>
                <h2 className={css("visual-title", "text-ellipsis", !this.props.suppressDefaultPadding && "self-padded")} tabIndex={0}>
                    {!this.props.hideTitle && this.props.text}
                    {this.props.dataQualityWarning && <DataQualityWarningsComponent warning={this.props.dataQualityWarning} />}
                    {this.props.children}
                </h2>
            </Tooltip>
        );
    }
}
